import api from './client'

export interface UnderCoveredGoal {
  goalId: string
  goalName: string
  shortfall: number
}

export interface UnderCoveredGoalsSummary {
  count: number
  goals: UnderCoveredGoal[]
}

export type DashboardPeriod = 'THIS_MONTH' | 'LAST_MONTH' | 'THIS_YEAR' | 'ALL_TIME'

export interface CategorySpend {
  categoryId: string | null
  name: string
  icon: string | null
  total: number
  sharePercent: number
}

export interface DashboardResponse {
  netWorth: number
  periodIncome: number
  periodExpenses: number
  savingsRate: number | null
  spendingByCategory: CategorySpend[]
  underCoveredGoals: UnderCoveredGoalsSummary
  /**
   * One entry per day from the 1st through today; only filled for THIS_MONTH. Optional
   * because a backend older than the frontend (deploy order) doesn't send it.
   */
  dailySpending?: DailySpend[]
}

export interface DailySpend {
  date: string
  total: number
}

export function fetchDashboard(period: DashboardPeriod = 'THIS_MONTH'): Promise<DashboardResponse> {
  return api.get('/dashboard', { params: { period } }).then((r) => r.data)
}
